import React from 'react';

import {useTranslation} from 'react-i18next';

import {Page} from 'components/common/Page';

import {CommonData} from './CommonData';
import {ProfileNavigationTabs} from './NavigationTabs';
// import {Participants} from './Participants';
import {Wrapper} from './styled';

export const ProfilePage = () => {
    const {t} = useTranslation();

    return (
        <Page title={t('pages.profile.title')}>
            <Wrapper>
                <ProfileNavigationTabs />
                <CommonData />
                {/* <Participants /> */}
            </Wrapper>
        </Page>
    );
};
